import { css } from "@emotion/react";

export const VipDetailsMobileStyle = {
  wrapper: css``,

  banner: css`
    height: 60.94px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,

  swiper: css`
    position: relative;
  `,

  private: css`
    position: absolute;
    height: 36px;
    width: 100%;
    top: 175px;
    background: linear-gradient(88deg, #fdffd1 0%, #fefff0 84%, #fff 100%);

    display: flex;
    align-items: center;
    justify-content: center;

    span {
      height: 30px;
      width: 100%;
      text-align: center;
      line-height: 30px;
      font-weight: 700;
      color: #000;
      border-top: 1px solid #f1da6f;
      border-bottom: 1px solid #f1da6f;
    }
  `,

  mainContent: css`
    padding: 0 12px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,

  groupBenefit: css`
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 10px;

    position: absolute;
    left: 50%;
    top: 230px;

    width: 75%;

    transform: translateX(-50%);
  `,

  textBox: css`
    position: absolute;
    top: 70px;
    text-align: center;
    width: 100%;
    padding: 0 10px;

    span {
      color: #000;
      font-family: "Roboto";
      font-style: normal;
      font-size: 12px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      line-height: 1.42857143;
    }
  `,

  itemBenefit: css`
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,
};
